import { ArrowLeft, LooksTwo } from "@mui/icons-material";
import { Box, styled, Typography } from "@mui/material";
import { COLORS } from "../../../ui/Theme";
import LooksOne from "@mui/icons-material/LooksOne";
import { ListDivider } from "../../../ui/ListStyles";
const Caption = styled("p")({
  fontSize: "12px",
  color: COLORS.GRAY,
  display: "flex",
  alignItems: "center",
  gap: "8px",
});
const GlobalMarketSpreadPriceChartFavoriteCard = ({ favorite }) => {
  const {
    industry_1_name,
    commodity_type_1_name,
    commodity_1_name,
    transit_1_name,
    industry_2_name,
    commodity_type_2_name,
    commodity_2_name,
    transit_2_name,
  } = favorite;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "8px",
      }}
    >
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LooksOne sx={{ fontSize: "16px", color: COLORS.BLUE }} />
          {industry_1_name}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <Caption>
            {commodity_type_1_name}
            {commodity_1_name && <ArrowLeft />}
          </Caption>

          <Caption>
            {commodity_1_name}
            {transit_1_name && <ArrowLeft />}
          </Caption>

          <Caption>{transit_1_name}</Caption>
        </Box>
      </Box>
      <ListDivider />
      <Box>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <LooksTwo sx={{ fontSize: "16px", color: COLORS.BLUE }} />
          {industry_2_name}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
          }}
        >
          <Caption>
            {commodity_type_2_name}
            {commodity_2_name && <ArrowLeft />}
          </Caption>

          <Caption>
            {commodity_2_name}
            {transit_2_name && <ArrowLeft />}
          </Caption>

          <Caption>{transit_2_name}</Caption>
        </Box>
      </Box>
    </Box>
  );
};

export default GlobalMarketSpreadPriceChartFavoriteCard;
